import { render, staticRenderFns } from "./FiltersDropdowns.vue?vue&type=template&id=3f71e92a&"
import script from "./FiltersDropdowns.vue?vue&type=script&lang=js&"
export * from "./FiltersDropdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports